<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JgAhZL/tc-custom/9781453213841.jpg?1733096587056" alt="This image is the cover for the book Cousins"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cousins
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Cammy’s only trouble in life is a cousin named Patty Ann who overshadows her in every way—until suddenly, Patty Ann is no longer around</b> <br/>Cammy has a happy life and a great family, except for one little problem: a cousin who thinks she’s better than everyone else. It’s true that Patty Ann is beautiful, talented, and bright, but to Cammy she’s also vain, conceited, and mean-spirited. Sometimes Cammy wishes that Patty Ann would disappear, just vanish in a puff of smoke. But when the unthinkable happens and Patty Ann is lost forever, Cammy struggles to atone for her bad feelings toward someone so close.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia  Hamilton
      </h2>
      
      <p class="authorDescription body article"><P>Virginia Hamilton (1934&ndash;2002) was the author of over forty books for children, young adults, and their older allies. Throughout a career that spanned four decades, Hamilton earned numerous accolades for her work, including nearly every major award available to writers of youth literature. In 1974, <I>M.C. Higgins, the Great</I> earned Hamilton the National Book Award, the Newbery Medal (which she was the first African-American author to receive), and the <I>Boston Globe&ndash;Horn </I><I>Book</I> Award, three of the field&rsquo;s most prestigious awards. She received the Hans Christian Andersen Award, the highest international recognition bestowed on a writer of books for young readers, in 1992, and in 1995 became the first children&rsquo;s book author to receive a MacArthur Fellowship, or &ldquo;Genius Award.&rdquo; She was also the recipient of the Coretta Scott King Award.</P><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?134ba2c8